module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/digiSmart.103a31d7.png";